<template>
  <div class="reviews">
    <div
      class="review"
      v-for="(review, index) in displayedReviews"
      :id="'comment-' + review.id"
      :key="index"
    >
      <div class="review-header">
        <div class="stars-date">
          <speaker-stars :stars="review.stars" />
          <div class="date">{{ review.date }}</div>
        </div>
        <div class="name-company">
          <div class="name">{{ review.name }}</div>
          <div class="company">{{ review.company }}</div>
        </div>
      </div>
      <div class="review-content">
        <p>{{ review.comment }}</p>
      </div>
    </div>
    <button v-if="reviews.length > 3" @click="toggleShowAll">
      {{ showAll ? "Skjul alle" : "Vis alle" }}
    </button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showAll: false
    };
  },
  props: ["reviews"],
  computed: {
    displayedReviews() {
      return this.showAll ? this.reviews : this.reviews.slice(0, 3);
    }
  },
  methods: {
    toggleShowAll() {
      this.showAll = !this.showAll;
    }
  }
};
</script>
<style scoped>
.reviews {
  display: grid;
  gap: 20px;

  .review {
    padding: 80px 100px 64px;
    background: #2f42861a;

    @media screen and (max-width: 768px) {
      padding: 40px 40px 32px;
    }
  }

  .review-header {
    margin-bottom: 10px;
  }

  .stars-date {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .date {
    margin-left: 10px;
    font-size: 14px;
    line-height: 17px;
    color: #2f4286;
  }

  .name-company {
    margin: 15px 0;
    font-size: 16px;
    line-height: 24px;
    color: #2f4286;
  }

  .name {
    font-weight: bold;
  }

  .company {
    font-size: 14px;
  }

  .review-content {
    margin-top: 10px;
  }

  button {
    padding: 10px 20px;
    background-color: transparent;
    color: #2f4286;
    text-decoration: underline;
    border: none;
    cursor: pointer;
    outline: none;
    margin: 0 auto;
  }
}
</style>
